module.exports = __webpack_public_path__ + "img/UTEDGE.0ea2cd8a.png";